export default __webpack_public_path__ + "07d7b137fd80aa271daccbe2693cd354.png";